define('common/js/lib/Pubsub',['signals'], function(Signals) {

  'use strict';

  var listenersByEvent = {};

  function getSignal(event, options) {
    if (!listenersByEvent[event]) {
      var signal = new Signals();
      listenersByEvent[event] = signal;
    }
    changeOptions(event, options || {});
    return listenersByEvent[event];
  }

  function once(event, callback, context) {
    var signal = getSignal(event);
    signal.addOnce(callback, context);
    return signal;
  }

  function subscribe(event, callback, context) {
    var signal = getSignal(event);
    signal.add(callback, context);
    return signal;
  }

  function unsubscribe(event, callback, context) {
    var signal = getSignal(event);
    signal.remove(callback, context);
    return signal;
  }

  function changeOptions(event, options) {
    var signal = listenersByEvent[event];
    if (!signal) {
      return;
    }
    for (var i in options) {
      if (options.hasOwnProperty(i)) {
        signal[i] = options[i];
      }
    }
  }

  function publish(event, data, options) {
    var signal = getSignal(event, options);
    signal.dispatch(data);
    return signal;
  }

  return {
    getSignal: getSignal,
    once: once,
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    publish: publish
  };
});
